module.exports = __webpack_public_path__ + "../images/center_align_horizontal.png";